(function() {
// Swipe table
  let startXs;
  let scrollLefts;
  let swipeTable = document.querySelectorAll(".swipeTable");

  if (swipeTable.length > 0) {
    swipeTable.forEach(function(element) {
      element.addEventListener("touchstart", function (e) {
        startXs = e.touches[0].pageX;
        scrollLefts = element.scrollLeft;
      });

      element.addEventListener("touchmove", function (e) {
        let x = e.touches[0].pageX - startXs;
        element.scrollLeft = scrollLefts - x;
      });
    });
  }

// Caption
  let fixedCaptions = document.querySelectorAll('caption');

  function updateCaptions() {
    fixedCaptions.forEach(caption => {
      let container = caption.closest('[class*="table-"]');
      
      if (container) {
        caption.style.width = `${container.clientWidth}px`;
        let scrollPositionLeft = container.scrollLeft;
        caption.style.transform = `translateX(${scrollPositionLeft}px)`;
      }
    });
  }

  let tableContainers = document.querySelectorAll('[class*="table-"]');
  
  if (tableContainers.length > 0) {
    tableContainers.forEach(container => {
      container.addEventListener('scroll', updateCaptions);
    });

    window.addEventListener('resize', updateCaptions);
    
    updateCaptions();
  }

}());